module.exports = __webpack_public_path__ + "img/4.1799e234.jpg";